import { Box, } from '@mui/material'
import React from 'react'
import InputController from '../../../../components/InputController/InputController'
import DatePickerController from '../../../../components/CustomDatepicker/CustomDatePicker';
import { ParentContainerSection } from '../DiabeticForm';
const IdentifyingSection = (props) => {
    const { control, errors, getValues } = props
  return (
    <ParentContainerSection  heading="Section A - Identifying Data">
    <Box sx={{display: "flex",  gap:"0.5rem", flexWrap: "wrap", mb: "1rem"}}>
         <InputController
                                   name="patient_name"
                                   label="Patient Name"
                                   control={control}
                                   errors={errors}
                                   isSmall={true}
                                   size="small"
                                   isDisabled={true}
                                   defaultheight={false}
                                   // icon={<HotelRoundedIcon/>}
                           />  


         <InputController
                                   name="patient_gender"
                                   label="Sex"
                                   control={control}
                                   errors={errors}
                                   isSmall={true}
                                   size="small"
                                   isDisabled={true}
                                   defaultheight={false}
                                   // icon={<WcRoundedIcon/>}
                           />  
         <InputController
                                   name="cmis_number"
                                   label="CMIS Number"
                                   control={control}
                                   errors={errors}
                                   isSmall={true}
                                   size="small"
                                   isDisabled={true}
                                   defaultheight={false}
                                   // icon={<VerifiedRoundedIcon/>}
                           />  

<DatePickerController name="patient_dob"
                            label="DOB"
                             control={control}
                              errors={errors}
                               readOnly={true}
                               defaultheight={false}
                                />
                                </Box>
   </ParentContainerSection>
  )
}

export default IdentifyingSection